import { useMutation } from "@tanstack/react-query";
import { requestApi, requestFile } from "@api/baseApi";

export const useBaseMutation = (fn, axiosOptions = {}, tanstackOptions = {}) => {
  return useMutation({
    mutationFn: async (overrideOptions = {}) => {
      return await fn({ ...axiosOptions, ...overrideOptions });
    },
    ...tanstackOptions,
  });
};

export const useBaseApiMutation = (axiosOptions, tanstackOptions) => {
  return useBaseMutation(requestApi, axiosOptions, tanstackOptions);
};

export const useBaseFileMutation = (axiosOptions, tanstackOptions) => {
  return useBaseMutation(requestFile, axiosOptions, tanstackOptions);
};

// Example Usage:

// Create a user (POST request)
// const { mutate, isLoading, error } = useBaseApiMutation(
//   { endpoint: "users", method: "POST" },
//   { onSuccess: (data) => console.log("User created!", data) }
// );

// Call it somewhere:
// mutate({ data: { name: "John" } });

// Upload file (POST request)
// const { mutate: uploadFile } = useBaseFileMutation(
//   { endpoint: "upload", method: "POST" },
//   { onSuccess: () => console.log("File uploaded!") }
// );

// Upload a file
// uploadFile({ data: fileObject });